export default __webpack_public_path__ + "static/14_luminosity-df29ae7a58d3842b4c41a47780e29f28.png";